import { http } from "api/http";
import R from "ramda";

export const fetchUsageDetails = (accountId) => (
  http.get(`accounts/${accountId}?include_usage=true`)
    .then(response => {
      const usageDetails = R.pathOr([], ["data", "plan"], response);
      return usageDetails;
    })
);

export const fetchDocumentUsageDetails = (accountId, urlParams) => (
  http.get(`accounts/${accountId}/documents?${urlParams}`)
    .then(response => response.data)
);



// WEBPACK FOOTER //
// ./src/js/api/dashboard.js